import jump from 'lib/jump';
import { actions } from 'modules/user';
import * as selectors from 'modules/user/selectors';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { branch, compose, renderComponent } from 'recompose';
import { asyncConnect } from 'redux/shelf';
import { createStructuredSelector } from 'reselect';
import FormLeavingPrompt from './FormLeavingPrompt';

import styles from './styles.css';

import { Redirect } from 'react-router';
import Header from './Header';

const mapStateToProps = createStructuredSelector({
  user: selectors.user.getUser,
  merchantId: selectors.user.getSelectedMerchantId,
  onboardingID: selectors.user.getSelectedMerchantOnboardingId,
});

const scrollTo = (element) => {
  const context = document.querySelector('#content');
  jump(element, { context, offset: -75, duration: 500 });
};

const ApplicationLayout = compose(
  connect(mapStateToProps),
  asyncConnect(({ user, dispatch }) => !user && dispatch(actions.getUser())),
  asyncConnect(
    ({ merchantId, dispatch }) =>
      merchantId && dispatch(actions.getMerchant({ id: merchantId }))
  ),
  branch(
    ({ allow, ...rest }) => allow && !allow(rest),
    renderComponent(({ redirect }) => <Redirect to={redirect} />)
  )
)(({ children, onScroll, sidebar: Sidebar, ...rest }: any) => {
  useEffect(() => {
    const { hash } = rest.location;
    if (!hash) return;
    const element = document.querySelector(hash);
    if (element) scrollTo(element);
  }, [rest.location.hash]);

  return (
    <div className={styles.root}>
      <Header {...rest} />
      <FormLeavingPrompt />
      <div className={styles.page}>
        {(Sidebar && (
          <Sidebar>
            <Switch>{children}</Switch>
          </Sidebar>
        )) || <Switch>{children}</Switch>}
      </div>
    </div>
  );
});

export default ApplicationLayout;
